import { render, staticRenderFns } from "./BkkRelease.vue?vue&type=template&id=4ba94e14&scoped=true&"
import script from "./BkkRelease.vue?vue&type=script&lang=js&"
export * from "./BkkRelease.vue?vue&type=script&lang=js&"
import style0 from "./BkkRelease.vue?vue&type=style&index=0&id=4ba94e14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba94e14",
  null
  
)

export default component.exports